export default __webpack_public_path__ + "static/media/money.60d73b21.png";